module.exports = __webpack_public_path__ + "img/5-1.eff72701.png";